import API from "../../../../services/api-request";
import state from "../../../../config/valtio/store";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Table, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import FilterMenu from "./filter-menu";
import AddProduct from "./modal-add-product";
import EditProduct from "./modal-edit-product";
import "../../../../assets/css/style-table.css";

const { confirm } = Modal;

const Product = () => {
  const [dataProduct, setDataProduct] = useState([]);
  const [dataProductFilter, setDataProductFilter] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  // Edit Modal Variable Function
  const [showEdit, setShowEdit] = useState(false);
  const onShowEdit = (val) => {
    setShowEdit(val);
  };

  // Add Modal Variable & Function
  const [showAdd, setShowAdd] = useState(false);
  const onShowAdd = (val) => {
    setShowAdd(val);
  };

  const getProduct = async () => {
    state.LOADING = true;

    await API.Get("product")
      .then((result) => {
        setDataProduct(result?.data);
        setDataProductFilter(result?.data);
      })
      .catch((err) => {
        console.error(err);
        message.info("Failed Fetch Product Data!");
      });

    state.LOADING = false;
  };

  useEffect(() => {
    getProduct();
  }, []);

  // Delete Confirm
  const showDeleteConfirm = (data) => {
    confirm({
      title: `Delete ${data.name}`,
      icon: <ExclamationCircleFilled />,
      content: `Are you sure delete ${data.name}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        API.Delete(`product/${data.id}`)
          .then(() => {
            message.success("Product has been deleted");
          })
          .catch((err) => {
            message.info("Failed delete Product");
            console.error(err);
          })
          .finally(() => {
            getProduct();
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const columns = [
    {
      title: "No.",
      key: "id",
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => {
        if (a.name === null || a.name === "-") return 1;
        if (b.name === null || b.name === "-") return -1;
        return a.name.localeCompare(b.name);
      },
      render: (name) => (name ? name : "-"),
    },
    {
      title: "Tipe",
      dataIndex: "product_type",
      key: "product_type",
      sorter: (a, b) => {
        if (a.product_type?.size === null || a.product_type?.size === "-")
          return 1;
        if (b.product_type?.size === null || b.product_type?.size === "-")
          return -1;
        return a.product_type?.size.localeCompare(b.product_type?.size);
      },
      render: (product_type) => (product_type ? product_type?.size : "-"),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => {
        if (a.created_at === null || a.created_at === "-") return 1;
        if (b.created_at === null || b.created_at === "-") return -1;
        return a.created_at.localeCompare(b.created_at);
      },
      render: (created_at) =>
        created_at ? dayjs(created_at).format("YYYY-MM-DD HH:mm:ss") : "-",
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "updated_at",
      sorter: (a, b) => {
        if (a.updated_at === null || a.updated_at === "-") return 1;
        if (b.updated_at === null || b.updated_at === "-") return -1;
        return a.updated_at.localeCompare(b.updated_at);
      },
      render: (updated_at) =>
        updated_at ? dayjs(updated_at).format("YYYY-MM-DD HH:mm:ss") : "-",
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      render: (data) => {
        return (
          <Row align="middle" gutter={[8, 8]}>
            <Col>
              <Button
                type="primary"
                onClick={() => {
                  setSelectedData({ ...data });
                  onShowEdit(true);
                }}
              >
                Edit
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm(data);
                }}
              >
                Delete
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  const onSearch = async (val) => {
    let data = dataProduct.filter((product) =>
      product.name.toLowerCase().includes(val.toLowerCase())
    );

    setDataProductFilter(data);
  };

  const onClear = async (val) => {
    getProduct();
  };

  const rowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  return (
    <>
      <FilterMenu onShowAdd={onShowAdd} onSearch={onSearch} onClear={onClear} />

      {/* Product Table */}
      <Table
        rowKey="id"
        columns={columns}
        dataSource={dataProductFilter}
        rowClassName={rowClassName}
        scroll={{
          x: 1000,
        }}
        size="large"
      />

      {/* Modal Add Product */}
      <div
        style={{ display: "flex", justifyContent: "flex-end", margin: "8px 0" }}
      >
        <AddProduct
          showAdd={showAdd}
          onShowAdd={onShowAdd}
          onGetProduct={getProduct}
        />
      </div>

      {/* Modal Edit Product */}
      <EditProduct
        showEdit={showEdit}
        onShowEdit={onShowEdit}
        onGetProduct={getProduct}
        selectedData={selectedData}
      />
    </>
  );
};

export default Product;
